var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8425 6.99793H10.9998V5.15517C10.9995 4.31753 11.332 3.51409 11.9241 2.92161C12.5162 2.32912 13.3194 1.99611 14.1571 1.99585H16.0018V3.83862C16.0013 5.58323 14.5871 6.99738 12.8425 6.99793V6.99793Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 7.50811V6.49768C10.9998 5.1164 9.88003 3.99664 8.49874 3.99664H7.99854",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9992 15.0012H20.0034C20.5559 15.0012 21.0038 15.4491 21.0038 16.0016V16.0016C21.0038 19.3167 18.3164 22.0041 15.0013 22.0041V22.0041C11.6862 22.0041 8.99878 19.3167 8.99878 16.0016V16.0016C8.99878 15.4491 9.44668 15.0012 9.9992 15.0012Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6399 20.9737C11.4299 20.9937 11.2198 21.0038 10.9997 21.0038C8.87688 21.0043 6.84086 20.1613 5.33982 18.6603C3.83877 17.1592 2.99575 15.1232 2.99634 13.0004C2.99634 9.50897 4.59701 6.99792 7.79834 6.99792C8.87554 7.09718 9.94499 7.26762 10.9997 7.50813C12.0544 7.26762 13.1238 7.09718 14.201 6.99792C15.606 6.93758 16.9514 7.56919 17.8025 8.68862C18.6527 9.96087 19.0734 11.4718 19.003 13.0004C19.0018 13.6751 18.9178 14.3471 18.7529 15.0013",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnack);
export default __webpack_public_path__ + "static/media/snack.ef7c749e5bde8de4115c388410b4a5ee.svg";
export { ForwardRef as ReactComponent };